import React from 'react';

const QuestionItem = props => {
  return (
    <div
      className={`questions-pagination-item ${
        props.activeQuestion === props.index + 1 ? 'active' : ''
      }`}
      onClick={props.changeActiveQuestion.bind(this, props.index + 1)}
    >
      {props.numberQuestion}
    </div>
  );
};

export default QuestionItem;
